export enum CustomEvents {
  SYNC_SAVED = 'sync_saved'
}
